// move form into popup
// uk form id: 630108
// us form id: 651471
// eu form id: 651449
const checkAndMove = () => {
    const formIds = ['630108', '651449', '651471'];
    let formsElement = null;

    // Try to find any of the three form IDs
    for (const id of formIds) {
        formsElement = document.querySelector(`[data-forms-id="forms-root-${id}"]`);
        if (formsElement) break;
    }

    const container = document.getElementById('bis-vote-popup-inner');

    if (formsElement && container) {
        container.appendChild(formsElement);
        initiateVoteBisPopup();
        return;
    } else {
        setTimeout(checkAndMove, 100);
    }
};

checkAndMove();

let vote_bis_variant_id = '';

// Helper function to find inputs in shadow DOM
function getFormInputs() {
    const popup = document.getElementById('bis-vote-popup');
    const formEmbed = popup.querySelector('form-embed');

    if (formEmbed && formEmbed.shadowRoot) {
        const allInputs = formEmbed.shadowRoot.querySelectorAll('input');
        const variantInput = Array.from(allInputs).find(input => input.id === 'custom#variantid');
        const emailInput = formEmbed.shadowRoot.querySelector('#email');
        const emailLabel = formEmbed.shadowRoot.querySelector('#label-email');

        return { variantInput, emailInput, emailLabel };
    }

    return { variantInput: null, emailInput: null, emailLabel: null };
}

// Function to check if form inputs still exist (if not, form was submitted)
function hasFormInputs() {
    const popup = document.getElementById('bis-vote-popup');
    const formEmbed = popup.querySelector('form-embed');

    if (formEmbed && formEmbed.shadowRoot) {
        const emailInput = formEmbed.shadowRoot.querySelector('#email');
        const submitButton = formEmbed.shadowRoot.querySelector('button[type="submit"], input[type="submit"]');

        // If we can't find the email input or submit button, form has been submitted
        return !!(emailInput && submitButton);
    }

    return false; // If we can't access shadow DOM, assume form was submitted
}

function populateVoteBisVariantIdInput() {
    const { variantInput } = getFormInputs();
    if (variantInput && vote_bis_variant_id) {
        variantInput.value = vote_bis_variant_id;
        // Trigger input event to notify form validation
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

// Monitor and repopulate variant input if cleared
function startVariantInputMonitoring() {
    const monitorInterval = setInterval(() => {
        if (vote_bis_variant_id) {
            const { variantInput } = getFormInputs();
            if (variantInput && !variantInput.value) {
                populateVoteBisVariantIdInput();
            }
        }
    }, 50);

    window.variantMonitorInterval = monitorInterval;
}

function initiateVoteBisPopup() {
    const triggers = document.querySelectorAll('a.vote-bis-popup-trigger');
    const popup = document.getElementById('bis-vote-popup');
    const popup_close_btn = document.getElementById('close-bis-vote-popup');

    triggers.forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            popup.style.display = 'block';

            // Get variant id from the button and store it
            const variantId = trigger.getAttribute('data-product-variant');
            if (variantId) {
                vote_bis_variant_id = variantId;
                populateVoteBisVariantIdInput();

                // Start monitoring the input
                startVariantInputMonitoring();

                // Hide variant input container
                const { variantInput } = getFormInputs();
                if (variantInput) {
                    const containerDiv = variantInput.closest('div');
                    if (containerDiv) {
                        containerDiv.style.display = 'none';
                    }
                }
            }

            // Setup email input styling
            const { emailInput, emailLabel } = getFormInputs();
            if (emailInput && emailLabel) {
                // Apply label styling immediately when popup opens
                emailLabel.style.top = '17px';

                // Watch for changes to the label's style and override them
                const observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                            if (emailLabel.style.top !== '17px') {
                                emailLabel.style.top = '17px';
                            }
                        }
                    });
                });

                observer.observe(emailLabel, {
                    attributes: true,
                    attributeFilter: ['style']
                });

                emailInput.addEventListener('input', function () {
                    populateVoteBisVariantIdInput();
                });
            }

            // Setup form submission handlers
            setupFormSubmissionHandlers();
        });
    });

    // Close button functionality
    if (popup_close_btn) {
        popup_close_btn.addEventListener('click', function (e) {
            e.preventDefault();
            popup.style.display = 'none';
            if (window.variantMonitorInterval) {
                clearInterval(window.variantMonitorInterval);
            }

            // Check if form inputs still exist - if not, form was submitted
            if (!hasFormInputs()) {
                location.reload();
            }
        });
    }

    // Overlay click to close
    const overlay = document.querySelector('.site-overlay');
    if (overlay) {
        overlay.addEventListener('click', function (e) {
            if (!e.target.closest('.site-popup')) {
                popup.style.display = 'none';
                if (window.variantMonitorInterval) {
                    clearInterval(window.variantMonitorInterval);
                }

                // Check if form inputs still exist - if not, form was submitted
                if (!hasFormInputs()) {
                    location.reload();
                }
            }
        });
    }
}

function setupFormSubmissionHandlers() {
    const { variantInput } = getFormInputs();
    if (variantInput) {
        const form = variantInput.closest('form');
        if (form) {
            // Handle form submission events
            ['submit', 'beforesubmit'].forEach(eventType => {
                form.removeEventListener(eventType, handleFormSubmit);
                form.addEventListener(eventType, handleFormSubmit);
            });

            // Handle submit button clicks
            const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
            submitButtons.forEach(button => {
                button.removeEventListener('click', handleSubmitButtonClick);
                button.addEventListener('click', handleSubmitButtonClick);
            });
        }
    }
}

function handleSubmitButtonClick(e) {
    populateVoteBisVariantIdInput();

    setTimeout(() => {
        populateVoteBisVariantIdInput();
    }, 10);
}

function handleFormSubmit(e) {
    populateVoteBisVariantIdInput();

    const { variantInput } = getFormInputs();
    if (!variantInput || !variantInput.value) {
        // Retry if it didn't work the first time
        setTimeout(() => {
            populateVoteBisVariantIdInput();
        }, 100);
    }
}